<template>
  <div>
    <HomeworkList v-if="curPage=='HomeworkList'" @changePage="changePage" />
    <HomeworkDetail :query="HomeworkDetailQuery" @changePage="changePage" v-if="curPage=='HomeworkDetail'"/>
    <!-- 考试模式 -->
    <QuestionPaper v-if="curPage=='QuestionPaper'" @changePage="changePage" :query="QuestionPaperQuery"/>
    <!-- 逐题模式 -->
    <GraduallyTi v-if="curPage=='GraduallyTi'" @changePage="changePage" :query="QuestionPaperQuery"/>
    <!-- 提交作业提示 -->
    <Provideinstructions v-if="curPage=='Provideinstructions'" @changePage="changePage" :query="QuestionPaperQuery"/>
  </div>
</template>

<script>
import HomeworkList from './homeworkList.vue'
import HomeworkDetail from './homeworkDetail.vue'
import QuestionPaper from './questionPaper.vue'
import GraduallyTi from './GraduallyTi.vue'
import Provideinstructions from './Provideinstructions.vue'

export default {
  data(){
    return{
      curPage:'HomeworkList',
      HomeworkDetailQuery:{},
      QuestionPaperQuery:{}
    }
  },

  components:{
    HomeworkList,
    HomeworkDetail,
    QuestionPaper,
    GraduallyTi,
    Provideinstructions
  },
  methods:{
    changePage(payload){
      console.log(payload)
      const {query, page} = payload
      this.curPage = page
      if(page == 'HomeworkDetail'){
        this.HomeworkDetailQuery = query
        this.$emit('changeUnread')
        return
      }
      if(page == 'QuestionPaper'){
        this.QuestionPaperQuery = query
        return
      }
      if(page == 'GraduallyTi'){
        this.QuestionPaperQuery = query
        return
      }
      if(page == 'Provideinstructions'){
        this.QuestionPaperQuery = query
        return
      }
    }
  }
}
</script>

<style lang="scss" scoped>


</style>
